export default __webpack_public_path__ + "static/media/no-device-icon.a6717771.svg";